module.exports = __webpack_public_path__ + "img/succeed.b3fd27f0.png";